import { action, atom } from '@reatom/core';
import { withLocalStorage } from '@reatom/persist-web-storage';

const recentSearchAtom = atom(new Array<string>()).pipe(
  withLocalStorage('recentSearchAtom'),
);

const clearRecentSearchAction = action((ctx) => {
  recentSearchAtom(ctx, []);
}, 'clearRecentSearchAction');

const removeRecentSearchAction = action((ctx, index: number) => {
  recentSearchAtom(ctx, (state) => {
    if (index < 0 || index >= state.length) return state;
    return [...state.slice(0, index), ...state.slice(index + 1)];
  });
}, 'removeRecentSearchAction');

const addRecentSearchAction = action((ctx, payload: string) => {
  recentSearchAtom(ctx, (state) => {
    const filteredState = state.filter((t) => t !== payload);
    return [payload, ...filteredState].slice(0, 10);
  });
}, 'addRecentSearchAction');

export {
  recentSearchAtom,
  clearRecentSearchAction,
  addRecentSearchAction,
  removeRecentSearchAction,
};
